import { getUniqueId } from '../utils/get-unique-id';

export type MarkRaw = Partial<Omit<Mark, 'time'>> & { time?: number | Date };

export class Mark {
  delta!: number;
  deltaLap!: number;
  deltaStart!: number;
  deltaLeader!: number;
  joker!: number;
  manualEdit!: string;
  marshal!: number;
  obligatory!: number;
  time!: Date | null;
  delete = false;
  uid!: string;
  timebar!: number;

  constructor(obj?: MarkRaw) {
    if (obj) {
      this.update(obj);
    }
  }

  update(obj: MarkRaw) {
    if (!obj.uid) {
      this.uid = getUniqueId(2);
    } else {
      this.uid = obj.uid;
    }
    this.delta = obj.delta ?? 0;
    this.joker = obj.joker ?? 0;
    this.manualEdit = obj.manualEdit ?? '';
    this.marshal = obj.marshal ?? 0;
    this.obligatory = obj.obligatory ?? 0;
    if (obj.time) {
      this.time = new Date(obj.time);
    }
    this.deltaLap = obj.deltaLap ?? 0;
    this.deltaStart = obj.deltaStart ?? 0;
    this.deltaLeader = obj.deltaLeader ?? 0;
    this.timebar = obj.timebar ?? 0;
  }
}
